"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var utils_1 = require("./utils");
var const_1 = require("./const");
var createTableHeaderPlugin = function (props) {
    var TableHeaderItem = /** @class */ (function (_super) {
        __extends(TableHeaderItem, _super);
        function TableHeaderItem() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = const_1.NODE_NAME.TABLE_HEADER;
            _this.content = 'block+';
            _this.attrs = utils_1.createCellAttrs(props.defaultCellWidth, props.cellAttributes);
            _this.tableRole = 'header_cell';
            _this.isolating = true;
            _this.parseDOM = [
                {
                    tag: 'th',
                    getAttrs: function (dom) { return utils_1.getCellAttrs(dom, props.cellAttributes); }
                }
            ];
            _this.toDOM = function (node) {
                return ['th', utils_1.setCellAttrs(node, props.cellAttributes), 0];
            };
            return _this;
        }
        return TableHeaderItem;
    }(core_utilities_1.Block));
    return /** @class */ (function (_super) {
        __extends(TableHeaderPlugin, _super);
        function TableHeaderPlugin() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Schema = TableHeaderItem;
            return _this;
        }
        return TableHeaderPlugin;
    }(core_utilities_1.SylPlugin));
};
exports.createTableHeaderPlugin = createTableHeaderPlugin;
//# sourceMappingURL=table-header.js.map